import { getWorkspacesByUserId } from '@common/modules/workspaces/stores/workspaces.actions'
import type { Workspace } from '@common/modules/workspaces/types'

import { loadWorkspaceFromStore } from './loadWorkspaceFromStore'

export async function waitForWorkspaceInStore(maxAttempts: number, delayMs: number): Promise<Workspace | null> {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    await getWorkspacesByUserId()

    const workspace = loadWorkspaceFromStore()
    if (workspace) {
      return workspace
    }

    if (attempt < maxAttempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, delayMs))
    }
  }

  return null
}
